import React, { useContext } from "react";
import { MaterialRequestSortTypes } from "../../../configs/sortTypes";
import { MaterialRequestFilterType } from "../../../configs/filterTypes";
import ListView from "../../../shared/components/ListView";
import { TableColumns, Search } from "../../../configs/materialRequest";
import { MaterialRequestRow } from "./MaterialRequestTable";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";

const Content = () => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getTableColumns = () => {
        switch (role) {
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.SALE_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return TableColumns;
            default:
                return [];
        }
    };

    // console.log('table data here')
    return (
        <ListView
            url="/materials/requests/"
            // NPQT: Need to replace
            sortTypes={MaterialRequestSortTypes}
            filterTypes={MaterialRequestFilterType}
            rowElement={MaterialRequestRow}
            tableColumns={getTableColumns()}
            textString={Search.searchText}
        />
    );
};

export default Content;
